import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'degreeType',
  pure: true,
})
export class DegreeTypePipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string | null | undefined): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('نوع الدرجة غير محدد');
    }
    return this.lookupData.getDegreeTypes({
      selectedIds: [String(value)],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const name = result.items.find(d => String(d.id) === String(value))?.name;
        return name ?? 'نوع الدرجة غير محدد';
      })
    );
  }
}
